import {
  faDatabase,
  faEllipsisV, faExternalLink,
} from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import {
  RoundButtonComponent, RoundButtonSize,
} from '~/_shared/baseComponents/buttons/roundButton/roundButton.component';
import { RoundButtonStyle } from '~/_shared/baseComponents/buttons/roundButton/roundButton.styles';
import {
  ContextMenuComponent, ContextMenuDefaultItem, ContextMenuItemCoreComponent,
} from '~/_shared/baseComponents/contextMenu';
import { useTranslation } from '~/_shared/utils/hooks';

const triggerButtonStyle = ({ isMenuOpen, isTrialMode }: { isMenuOpen: boolean; isTrialMode?: boolean }) =>
  isTrialMode ? RoundButtonStyle.Restricted : isMenuOpen ? RoundButtonStyle.Quaternary : RoundButtonStyle.Primary;

export const ActiveDataLayerContextMenuComponent = ({
  isTrialMode,
  onExport,
  onSaveAsTemplate,
}: Readonly<{
  isTrialMode?: boolean;
  onExport?: () => void;
  onSaveAsTemplate?: () => void;
}>) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [t] = useTranslation();

  return (
    <ContextMenuComponent
      isVisible={isMenuOpen}
      onHide={() => setIsMenuOpen(false)}
      maxWidth={280}
      renderMenuContent={() => (
        <>
          {onSaveAsTemplate && (
            <ContextMenuItemCoreComponent>
              <ContextMenuDefaultItem
                icon={faDatabase}
                onClick={onSaveAsTemplate}
                size="s"
              >
                {t('Save as a Template')}
              </ContextMenuDefaultItem>
            </ContextMenuItemCoreComponent>
          )}

          {onExport && (
            <ContextMenuItemCoreComponent>
              <ContextMenuDefaultItem
                icon={faExternalLink}
                onClick={onExport}
                size="s"
              >
                {t('Export Data with Boundaries')}
              </ContextMenuDefaultItem>
            </ContextMenuItemCoreComponent>
          )}
        </>
      )}
    >

      <RoundButtonComponent
        icon={faEllipsisV}
        onClick={isTrialMode ? undefined : () => setIsMenuOpen(true)}
        size={RoundButtonSize.Small}
        buttonStyle={triggerButtonStyle({ isMenuOpen, isTrialMode })}
      />
    </ContextMenuComponent>
  );
};
